export default function WhatsAppButton() {
  const phoneNumber = '573112245754';
  const message = encodeURIComponent('Hola, me gustaría obtener más información sobre los productos de Esencia&co.');
  const waUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={waUrl}
      target="_blank"
      rel="noopener noreferrer nofollow"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:scale-110 hover:shadow-xl transition-all duration-300 cursor-pointer"
    >
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-75 animate-ping-slow" />
      <span className="relative z-10 w-7 h-7 flex items-center justify-center">
        <i className="ri-whatsapp-line text-2xl" />
      </span>
    </a>
  );
}